import React from 'react';

const PostComment = () => {
    return (
        <div className="form-submit">
            <input name="submit" type="submit" className="btn btn-secondary transform-scale-h" value="Submit" />
        </div>
    );
};

export default PostComment;
